'use strict';

var helper = require('../helper');

module.exports = {

    pushPromotionListImpression (promotions) {
        if (!promotions || promotions.length === 0) {
            return;
        }

        let pushObject = {
            'event': 'promoView',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'ecommerce': {
                'promoView': {
                    'promotions': promotions
                }
            }
        };

        helper.log('Pushing promotions list impression!', true);
        helper.push(pushObject);
    },

    pushPromotionClickImpression (promotion) {
        if (!promotion) {
            return;
        }

        let pushObject = {
            'event': 'promoClick',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'ecommerce': {
                'promoClick': {
                    'promotions': [promotion]
                }
            }
        };

        helper.log('Pushing promotion click impression!', true);
        helper.push(pushObject);
    },

    pushInfoBannerClickImpression (name) {
        if (!name) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '3',
            'eventname': 'banner_info',
            'label': name
        };

        helper.log('Pushing info banner click impression!', true);
        helper.push(pushObject);
    },

    // Customer Service
    pushCustomerServiceItemClick (topic) {
        if (!topic) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '17',
            'eventname': 'faq',
            'action': 'clic_on_topic',
            'text': topic
        };

        helper.log('Pushing customer service topic click for ' + topic + '!', true);
        helper.push(pushObject);
    },

    pushCustomerServiceItemExpand (topic, name) {
        if (!topic || !name) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '18',
            'eventname': 'faq',
            'action': 'general_info',
            'text': name
        };

        helper.log('Pushing customer service topic expand for ' + topic + ', ' + name + '!', true);
        helper.push(pushObject);
    },

    // 6.51 TEZENIS STORIES HOME
    pushTezenisStoriesItemClick (name) {
        if (!name) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '52',
            'eventname': 'home_stories',
            'type': 'icon',
            'text': name
        };

        helper.log('Pushing tezenis stories click for ' + name + '!', true);
        helper.push(pushObject);
    },

    // 6.52 TEZENIS STORIES HOME - CLICK ON AN ARROW
    pushTezenisStoriesArrowClick () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '53',
            'eventname': 'home_stories',
            'type': 'arrows'
        };

        helper.log('Pushing tezenis arrow click', true);
        helper.push(pushObject);
    },

    // 6.53
    pushTezenisCommunicationClick (text) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '54',
            'eventCategory': 'home_communication',
            'label': text
        };

        helper.log('Pushing tezenis communication click for ' + text + '!', true);
        helper.push(pushObject);
    },

    // 6.54
    pushTezenisCategoryClick (text) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '55',
            'eventname': 'home_categories',
            'text': text
        };

        helper.log('Pushing tezenis category click for ' + text + '!', true);
        helper.push(pushObject);
    }
};
